import { z } from 'zod';
import { makeFieldSchemaFromZod } from '../MultiEntityPickerRenderedString/utils';

export const SupplyWorkspacePickerFieldSchema = makeFieldSchemaFromZod(
  z.array(z.string()),
  z.object({
    system: z
      .string()
      .describe(
        'System entity ref without kind (namespace/name). Supports nunjucks templating over parameters, e.g. "{{ parameters.system }}"',
      ),
    environment: z
      .string()
      .describe(
        'OpenControl environment (development, staging or production). Supports nunjucks templating over parameters, e.g. "{{ parameters.environment }}"',
      ),
  }),
);

/**
 * The input props that can be specified under `ui:options` for the
 * `SupplyWorkspacePicker` field extension.
 */
export type SupplyWorkspacePickerUiOptions =
  typeof SupplyWorkspacePickerFieldSchema.uiOptionsType;

export type SupplyWorkspacePickerProps =
  typeof SupplyWorkspacePickerFieldSchema.type;

export const SupplyWorkspacePickerSchema =
  SupplyWorkspacePickerFieldSchema.schema;
